import { Product } from 'utils/Product';

export const mockProducts: Product[] = [
  {
    'id': 'CheerfulCapybaraID',
    'category': 'Stuffed Toys',
    'image': 'image-placeholder',
    'price': 29,
    'quantity': 5,
    'stars': 3,
    'title': 'Cheerful Capybara',
    'visible': true,
  },
  {
    'id': 'ExtinctCapybaraID',
    'category': 'Stuffed Toys',
    'image': 'image-placeholder',
    'price': 15,
    'quantity': 0,
    'stars': 4,
    'title': 'Extinct Capybara',
    'visible': true,
  },
  {
    'id': 'EndangeredCapybaraID',
    'category': 'Stuffed Toys',
    'image': 'image-placeholder',
    'price': 1,
    'quantity': 1,
    'stars': 1,
    'title': 'Endangered Capybara',
    'visible': false,
  },
  {
    'id': 'CopaceticCapybaraID',
    'category': 'Stuffed Toys',
    'image': 'image-placeholder',
    'price': 5,
    'quantity': 2,
    'stars': 4,
    'title': 'Copacetic Capybara',
    'visible': true,
  },
  {
    'id': 'ForlornCapybaraID',
    'category': 'Stuffed Toys',
    'image': 'image-placeholder',
    'price': 2,
    'quantity': 3,
    'stars': 1,
    'title': 'Forlorn Capybara',
    'visible': true,
  },
];
